module.exports = __webpack_public_path__ + "static/media/sharepoint.6cb832cc.svg";